import {inject, Injectable, Type, ViewContainerRef} from '@angular/core';
import {
    DynamicComponentCreationOptions,
    DynamicComponentFactoryService,
    DynamicComponentPlaceOptions,
    DynamicComponentRef
} from '../dynamic-component';

@Injectable()
export class ModalService extends DynamicComponentFactoryService {

    protected defaultViewContainerRef?: ViewContainerRef;

    /** ModalService of the parent injector, if provided there (fallback VCR) */
    protected readonly parentModalService: ModalService | null = inject(ModalService, {
        optional: true,
        skipSelf: true
    });

    public setDefaultViewContainerRef(defaultViewContainerRef: ViewContainerRef): void {
        this.defaultViewContainerRef = defaultViewContainerRef;
    }

    public getDefaultViewContainerRef(): ViewContainerRef | undefined {
        return this.defaultViewContainerRef
            ?? this.parentModalService?.getDefaultViewContainerRef();
    }

    public close<C>(modalInstance: C): void {
        this.destroyByInstance(modalInstance);
    }

    public open<C>(
        modalComponentClass: Type<C>,
        options?: DynamicComponentCreationOptions<C>
    ): DynamicComponentRef<C> {
        return this.create(modalComponentClass, {
            ...options,
            place: options?.place ?? this.resolveDefaultPlace()
        });
    }

    /** VCR of this service or of the nearest parent along the provider chain */
    protected resolveDefaultPlace(): DynamicComponentPlaceOptions {
        const viewContainerRef = this.getDefaultViewContainerRef();

        if (!viewContainerRef) {
            throw new Error(
                'ModalService: default ViewContainerRef is not set. ' +
                'Call setDefaultViewContainerRef() (usually in the root component) ' +
                'or pass place in the open() options.'
            );
        }

        return {viewContainerRef};
    }
}
